"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSalesforcePayloadSchema = void 0;
exports.EventSalesforcePayloadSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        eventType: {
            enum: [
                'Standard Visit',
                'Fly By Visit',
                'Training',
                'Demo Day',
                'Business Review',
                'New Product Demo',
                'Maintenance POS',
                'POS-installation fix',
                'Promo Execution',
                'Trade Show',
                'Special Events (no store attached)',
                'POS-installation',
                'Magnolia Design Center (MDC)',
                'Security',
                'Dealer Tech Issue',
                'New Subscription',
                'Renew Subscription',
                'Re-Subscription',
                'Resume Subscription',
                'Cancel',
                'Canceled Via Request',
                'Canceled Via Payment Failure',
                'Renewal after Payment Failure',
                'Email Notification',
                'Update Payment Method',
                'Trial Expiration',
                'Payment Method Expiring 30',
                'Payment Method Expiring 15',
                'Refund',
            ],
            type: 'string',
        },
        type: {
            enum: [
                'Email',
                'Meeting',
                'Other',
                'Call',
                'Subscription',
                'Entitlement',
                'Payment',
                'Payment Method',
                'Refund',
            ],
            type: 'string',
        },
        originalTransactionId: {
            type: 'string',
            minLength: 1,
        },
        sonosId: {
            type: 'string',
        },
        messageId: {
            type: 'string',
            minLength: 1,
        },
    },
    required: [
        'eventType',
        'type',
        'originalTransactionId',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLWV2ZW50LXNhbGVzZm9yY2Utc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2RvbXMvc2NoZW1hcy9zYWxlc2ZvcmNlL2NyZWF0ZS1ldmVudC1zYWxlc2ZvcmNlLXNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDRCQUE0QixHQUFHO0lBQzNDLE9BQU8sRUFBRSx5Q0FBeUM7SUFDbEQsVUFBVSxFQUFFO1FBQ1gsU0FBUyxFQUFFO1lBQ1YsSUFBSSxFQUFFO2dCQUNMLGdCQUFnQjtnQkFDaEIsY0FBYztnQkFDZCxVQUFVO2dCQUNWLFVBQVU7Z0JBQ1YsaUJBQWlCO2dCQUNqQixrQkFBa0I7Z0JBQ2xCLGlCQUFpQjtnQkFDakIsc0JBQXNCO2dCQUN0QixpQkFBaUI7Z0JBQ2pCLFlBQVk7Z0JBQ1osb0NBQW9DO2dCQUNwQyxrQkFBa0I7Z0JBQ2xCLDhCQUE4QjtnQkFDOUIsVUFBVTtnQkFDVixtQkFBbUI7Z0JBQ25CLGtCQUFrQjtnQkFDbEIsb0JBQW9CO2dCQUNwQixpQkFBaUI7Z0JBQ2pCLHFCQUFxQjtnQkFDckIsUUFBUTtnQkFDUixzQkFBc0I7Z0JBQ3RCLDhCQUE4QjtnQkFDOUIsK0JBQStCO2dCQUMvQixvQkFBb0I7Z0JBQ3BCLHVCQUF1QjtnQkFDdkIsa0JBQWtCO2dCQUNsQiw0QkFBNEI7Z0JBQzVCLDRCQUE0QjtnQkFDNUIsUUFBUTthQUNSO1lBQ0QsSUFBSSxFQUFFLFFBQVE7U0FDZDtRQUNELElBQUksRUFBRTtZQUNMLElBQUksRUFBRTtnQkFDTCxPQUFPO2dCQUNQLFNBQVM7Z0JBQ1QsT0FBTztnQkFDUCxNQUFNO2dCQUNOLGNBQWM7Z0JBQ2QsYUFBYTtnQkFDYixTQUFTO2dCQUNULGdCQUFnQjtnQkFDaEIsUUFBUTthQUNSO1lBQ0QsSUFBSSxFQUFFLFFBQVE7U0FDZDtRQUNELHFCQUFxQixFQUFFO1lBQ3RCLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDWjtRQUNELE9BQU8sRUFBRTtZQUNSLElBQUksRUFBRSxRQUFRO1NBQ2Q7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ1o7S0FDRDtJQUNELFFBQVEsRUFBRTtRQUNULFdBQVc7UUFDWCxNQUFNO1FBQ04sdUJBQXVCO0tBQ3ZCO0lBQ0QsSUFBSSxFQUFFLFFBQVE7Q0FDZCxDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IEV2ZW50U2FsZXNmb3JjZVBheWxvYWRTY2hlbWEgPSB7XG5cdCRzY2hlbWE6ICdodHRwOi8vanNvbi1zY2hlbWEub3JnL2RyYWZ0LTA3L3NjaGVtYSMnLFxuXHRwcm9wZXJ0aWVzOiB7XG5cdFx0ZXZlbnRUeXBlOiB7XG5cdFx0XHRlbnVtOiBbXG5cdFx0XHRcdCdTdGFuZGFyZCBWaXNpdCcsXG5cdFx0XHRcdCdGbHkgQnkgVmlzaXQnLFxuXHRcdFx0XHQnVHJhaW5pbmcnLFxuXHRcdFx0XHQnRGVtbyBEYXknLFxuXHRcdFx0XHQnQnVzaW5lc3MgUmV2aWV3Jyxcblx0XHRcdFx0J05ldyBQcm9kdWN0IERlbW8nLFxuXHRcdFx0XHQnTWFpbnRlbmFuY2UgUE9TJyxcblx0XHRcdFx0J1BPUy1pbnN0YWxsYXRpb24gZml4Jyxcblx0XHRcdFx0J1Byb21vIEV4ZWN1dGlvbicsXG5cdFx0XHRcdCdUcmFkZSBTaG93Jyxcblx0XHRcdFx0J1NwZWNpYWwgRXZlbnRzIChubyBzdG9yZSBhdHRhY2hlZCknLFxuXHRcdFx0XHQnUE9TLWluc3RhbGxhdGlvbicsXG5cdFx0XHRcdCdNYWdub2xpYSBEZXNpZ24gQ2VudGVyIChNREMpJyxcblx0XHRcdFx0J1NlY3VyaXR5Jyxcblx0XHRcdFx0J0RlYWxlciBUZWNoIElzc3VlJyxcblx0XHRcdFx0J05ldyBTdWJzY3JpcHRpb24nLFxuXHRcdFx0XHQnUmVuZXcgU3Vic2NyaXB0aW9uJyxcblx0XHRcdFx0J1JlLVN1YnNjcmlwdGlvbicsXG5cdFx0XHRcdCdSZXN1bWUgU3Vic2NyaXB0aW9uJyxcblx0XHRcdFx0J0NhbmNlbCcsXG5cdFx0XHRcdCdDYW5jZWxlZCBWaWEgUmVxdWVzdCcsXG5cdFx0XHRcdCdDYW5jZWxlZCBWaWEgUGF5bWVudCBGYWlsdXJlJyxcblx0XHRcdFx0J1JlbmV3YWwgYWZ0ZXIgUGF5bWVudCBGYWlsdXJlJyxcblx0XHRcdFx0J0VtYWlsIE5vdGlmaWNhdGlvbicsXG5cdFx0XHRcdCdVcGRhdGUgUGF5bWVudCBNZXRob2QnLFxuXHRcdFx0XHQnVHJpYWwgRXhwaXJhdGlvbicsXG5cdFx0XHRcdCdQYXltZW50IE1ldGhvZCBFeHBpcmluZyAzMCcsXG5cdFx0XHRcdCdQYXltZW50IE1ldGhvZCBFeHBpcmluZyAxNScsXG5cdFx0XHRcdCdSZWZ1bmQnLFxuXHRcdFx0XSxcblx0XHRcdHR5cGU6ICdzdHJpbmcnLFxuXHRcdH0sXG5cdFx0dHlwZToge1xuXHRcdFx0ZW51bTogW1xuXHRcdFx0XHQnRW1haWwnLFxuXHRcdFx0XHQnTWVldGluZycsXG5cdFx0XHRcdCdPdGhlcicsXG5cdFx0XHRcdCdDYWxsJyxcblx0XHRcdFx0J1N1YnNjcmlwdGlvbicsXG5cdFx0XHRcdCdFbnRpdGxlbWVudCcsXG5cdFx0XHRcdCdQYXltZW50Jyxcblx0XHRcdFx0J1BheW1lbnQgTWV0aG9kJyxcblx0XHRcdFx0J1JlZnVuZCcsXG5cdFx0XHRdLFxuXHRcdFx0dHlwZTogJ3N0cmluZycsXG5cdFx0fSxcblx0XHRvcmlnaW5hbFRyYW5zYWN0aW9uSWQ6IHtcblx0XHRcdHR5cGU6ICdzdHJpbmcnLFxuXHRcdFx0bWluTGVuZ3RoOiAxLFxuXHRcdH0sXG5cdFx0c29ub3NJZDoge1xuXHRcdFx0dHlwZTogJ3N0cmluZycsXG5cdFx0fSxcblx0XHRtZXNzYWdlSWQ6IHtcblx0XHRcdHR5cGU6ICdzdHJpbmcnLFxuXHRcdFx0bWluTGVuZ3RoOiAxLFxuXHRcdH0sXG5cdH0sXG5cdHJlcXVpcmVkOiBbXG5cdFx0J2V2ZW50VHlwZScsXG5cdFx0J3R5cGUnLFxuXHRcdCdvcmlnaW5hbFRyYW5zYWN0aW9uSWQnLFxuXHRdLFxuXHR0eXBlOiAnb2JqZWN0Jyxcbn1cbiJdfQ==